import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import cartIcon from 'assets/components/main_topbar/shopping-cart.svg'
import styles from './cart.scss'

class MainTopbarCart extends PureComponent {

	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<a
					styleName='link'
					onClick={this.props.goToCheckout}
				>
					<img
						styleName='link-image'
						src={cartIcon}
						alt='Cart'
					/>
				</a>
			</div>
		)
	}

}

MainTopbarCart.propTypes = {
	goToCheckout: PropTypes.func,
}

MainTopbarCart.defaultProps = {
	goToCheckout: () => {},
}

export default CSSModules(MainTopbarCart, styles, {allowMultiple: true})

export { MainTopbarCart }
